import { defineMessages } from 'react-intl';

const trns = defineMessages({
  searchDrugsTitle: {
    id: 'Uw1z50',
    defaultMessage: 'Пошук товарів {tradename}'
  },
  searchDrugsDescription: {
    id: '5jtBwS',
    defaultMessage:
      'У нашому каталозі лікарських засобів та інших товарів можна знайти найбільший вибір таких як {tradename}. Ця категорія товарів представлена різними виробниками та формами виготовлення.'
  },
  pharmacyWithDrugsTitle: {
    id: 'FLbfcm',
    defaultMessage: 'Аптеки де є {tradename}'
  },
  pharmacyWithDrugsDescription: {
    id: '4Lvo/V',
    defaultMessage:
      "Ми пропонуємо вибрати препарат {tradename} в аптеках вашого міста серед партнерів Аптека 911, АНЦ, АДД, Подорожник, Бажаємо Здоров'я та інші. Тому у вас є можливість вибирати їх як за місцем розташування, так і за ціною."
  },
  bookingTitle: {
    id: '8jSXHB',
    defaultMessage: 'Забронювати {tradename}'
  },
  bookingDescription: {
    id: 'jhpJS7',
    defaultMessage:
      ' У вас є можливість забронювати будь-який товар із запропонованих у каталозі {tradename} у найближчій аптеці вашого міста та забрати його у зручний час за обраною адресою.'
  },
  buyTitle: {
    id: 'SD5zPQ',
    defaultMessage: 'Придбати {tradename}'
  },
  buyDescription: {
    id: 'AkOJyV',
    defaultMessage:
      'Придбати {tradename} на сайті {link} дуже просто! Ціна на {tradename} гарантовано найнижча в вашомі місті і знаходиться в діапазоні від {minPrice} грн. до {maxPrice} грн. в залежності від обраного виробника.'
  },
  buyWithoutPriceDescription: {
    id: 'EBKSux',
    defaultMessage:
      'Придбати {tradename} на сайті {link} дуже просто! Ціна на {tradename} гарантовано найнижча в вашомі місті.'
  },
  buyVitaminsInOtherCities: {
    id: 'B/xE30',
    defaultMessage: 'Купити {tradeName} в інших містах'
  },
  letterName: {
    id: '1W/2Us',
    defaultMessage: 'Літера {letter}'
  },
  homeBreadCrumb: {
    id: '/YV5ee',
    defaultMessage: 'Головна'
  },
  unExpectedError: {
    id: 'hH/z0X',
    defaultMessage: 'На жаль, трапилась несподівана помилка. Спробуйте пізніше'
  }
});

export default trns;
